module.exports = __webpack_public_path__ + "static/media/BulletBlue.196b741a.svg";